import self from '../img/self.png';
import portfolio1 from '../img/portfolio1.png';
import portfolio2 from '../img/portfolio2.png';
import quizapp from '../img/quiz-app.jpeg';
import carImage from '../img/car-image.png';
import { colors } from '../colors/mainGradient';

export const info = {
  firstName: 'Nabin',
  lastName: 'Bagale',
  initials: 'NB',
  position: 'an Inspiring Full Stack Developer and Data Engineer',
  selfPortrait: self,
  gradient: `-webkit-linear-gradient(135deg, ${colors})`,
  baseColor: colors[0],
  miniBio: [
    {
      emoji: '🇨🇦',
      text: 'based in Canada',
    },
    {
      emoji: '🔍',
      text: 'Seeking a chance to excel in the role of a Software Developer, Data Engineer, Data Scientist, and Data Analyst',
    },
    {
      emoji: '💻',
      text: 'Data Engineer, Full Stack Developer',
    },
    {
      emoji: '📧',
      text: 'elninonaveen@gmail.com',
    },
  ],
  socials: [
    {
      link: 'https://github.com/nabinelnino',
      icon: 'fa fa-github',
      label: 'github',
    },
    {
      link: 'https://www.linkedin.com/in/nabin-bagale/',
      icon: 'fa fa-linkedin',
      label: 'linkedin',
    },
    // {
    //   link: 'https://nabin.com/nabin.pdf', // this should be https://yourname.com/resume.pdf once you've deployed
    //   icon: 'fa fa-file',
    //   label: 'resume',
    // },
    {
      link: 'https://www.instagram.com/elnino_naveen/',
      icon: 'fa fa-instagram',
      label: 'instagram',
    },

    {
      link: 'https://twitter.com/naveen_nino',
      icon: 'fa fa-twitter',
      label: 'twitter',
    },
  ],
  bio: "Hello! I'm Nabin. I'm a Data and Software Engineer. I have completed bachelor in CompSci and PG in Data Analytics, I enjoy building web applications, creating data pipelines, ETL/ELT process and learning new technologies. I love to travel and explore new places.",
  skills: {
    // you dont havew to strictly follow the 'languages', 'frameworks', 'databases', 'cloudServices', and 'tools' categories. You can add your own if you'd like.
    // but the structure should be the same, an array of strings and the key should be one word, no spaces.
    languages: ['Python', 'TypeScript', 'JavaScript', 'C#', 'R', 'SQL', 'HTML/CSS'],

    Machine_Learning: [
      'LLM',
      'OpenAI',
      'RAG',
      'NumPy',
      'SciPy',
      'Pandas',
      'Plotly',
      'Sci-kit Learn',
      'TensorFlow',
      'GGPlot2',
      'OpenCV',
      'NLTK',
    ],
    Data_Analytics: ['PowerBI', 'Tableau', 'Excel'],
    frameworks: [
      'PySpark',
      'Python',
      'FastAPI',
      'React',
      'Node',
      'Redux',
      'Material UI',
      'ASP.net MVC',
      'ASP.net Core',
      'Bootstrap/jQuery',
      'Flask',
      'Django',
    ],
    databases: ['MySQl', 'MongoDB', 'PostgreSQL', 'MsSQL', 'Graph DB', 'Firebase'],
    cloudServices: [
      'AWS S3',
      'AWS EC2',
      'AWS Lambda',
      'AWS RDS',
      'AWS EMR',
      'GCP',
      'GCP Dataproc',
      'GCP Data FLow',
      'Firebase',
      'BigQuery',
      'GCS',
      'Serverless Cloud Function',
      'Azure',
    ],
    tools: [
      'Git',
      'Postman',
      'Docker',
      'k8s',
      'ssh',
      'Swagger',
      'Elasticsearch',
      'npm',
      'yarn',
      'Jira',
      'Confluence',
      'Bitbucket',
    ],
  },
  hobbies: [
    {
      label: 'Soccer/Football',
      emoji: '⚽',
    },
    {
      label: 'Video Games',
      emoji: '🎮',
    },
    {
      label: 'Reading',
      emoji: '📖',
    },
    {
      label: 'Swimming',
      emoji: '🏊🏼‍♂',
    },
    {
      label: 'Cooking',
      emoji: '🍳',
    },
    {
      label: 'Traveling',
      emoji: '✈️',
    },
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    //   for the null ones, the button will not show up
    {
      title: 'Audio-Emotion-Detection',
      source: 'https://github.com/nabinelnino/Audio-Emotion-Detection', // this should be a link to the **repository** of the project, where the code is hosted.
      image: portfolio1,
      description:
        'This is the implementation of emotion detection from audio file, which classify the eight possible emotion from the given audio file. Audio emotion detection is a challenging task where language processing play a part to generate emotion from audio.',
    },
    {
      title: 'Stock ETF Pipeline and Prediction Model',
      source: 'https://github.com/nabinelnino/work-sample', // this should be a link to the **repository** of the project, where the code is hosted.
      image: portfolio2,
      description:
        "This project consists of an ETL pipeline to process stocks and ETFs (Exchange Traded Funds) data. The pipeline performs raw data processing and calculates the Moving Average and Rolling Mean of the data. Note: Since available dataset contains large volume of data, I've decided to use PySpark framework to process data in distributed manner and entire process is dockerized.",
    },
    {
      title: 'Fitness Quiz Application',
      live: null,
      source: 'https://github.com/nabinelnino/Developer-practice',
      image: quizapp,
      description:
        'This is a fitness recommendation application built with React. It helps users determine their fitness goals and provides recommendations based on their preferences.',
    },
    {
      title: 'Image-Classifier',
      source: 'https://github.com/nabinelnino/Image-Classifier',
      image: carImage,
      description:
        'The main goal of this Project is to create an image classifier from scratch using the Keras package.',
    },
    // {

    //   more: 'https://github.com/nabinelnino' //this should be a link to your github to show all project hosted on github
    // },
  ],

  experience: [
    // This is where your portfolio projects will be detailed
    //   for the null ones, the button will not show up

    {
      title: 'Data/Software Engineer',
      company: 'University of Toronto, Toronto, ON, Canada',
      year: 'Dec 2023- Present',
      description: [
        {
          role1:
            'Implement and manage cloud-based data workflows on AWS Glue and GCP’s Dataproc, employing PySpark, Python, and JavaScript to seamlessly process and ingest multi-source datasets, achieving over a 70% increase in runtime performance.',
          role2:
            'Orchestrate high-throughput data processing pipelines using Apache Airflow on AWS for handling terabytes of data, optimizing formats for efficient processing, and significantly reducing storage and processing costs by up to 20 times.',
          role3:
            'Develop internal software packages tailored to the specific needs of researchers and scientists, facilitating data analysis, visualization, and interpretation tasks.',
          role4:
            'Create bespoke chatbots leveraging OpenAI models for training, encompassing research paper analysis, documentation, research insights, and custom codebases to establish unique conversational models.',
          role5:
            'Design and implement user-friendly web tools, data pipelines, and analytics pipelines to provide researchers and scientists with easy access to requested data in their preferred formats, streamlining data retrieval and analysis processes.',
          role6:
            'Design and implement CI/CD pipelines using AWS services, streamlining data processing operations, resulting in a cloud cost reduction of over 60% and automating the deployment process.',
          role7:
            'Facilitate the ingestion of processed data into AWS data stores such as Amazon Redshift and S3, making it accessible for downstream use by ML engineers and researchers, and supporting concurrent analytical tasks.',
          role8:
            'Implement data governance practices to ensure data security and privacy for sensitive research data, achieving compliance with industry standards.',
        },
      ],
    },
    {
      title: 'Bioinformatics Analyst (Research Volunteer)',
      company: ' University Health Network',
      location: 'Toronto, ON, Canada',
      year: 'Jan 2024- Present',
      description: [
        {
          role1:
            'Analyze large-scale biological datasets using bioinformatics tools and statistical methods.',
          role2:
            'Ensure pipelines are efficient, reproducible, and scalable, using programming languages like Python, R, and tools such as Snakemake.',
          role3:
            'Interpret the results to derive meaningful biological insights and present findings to support research projects and clinical studies.',
          role4:
            'Manage and integrate biological databases to support data retrieval, storage, and analysis.',
        },
      ],
    },

    {
      title: 'Data/Software Engineer',
      company: 'Trade X, Mississuaga, ON, Canada',
      year: 'Jun 2022- Jun 2023',
      description: [
        {
          role1:
            'Designed and implemented highly available and scalable data pipelines using Python, SQL, GraphQL, Node.js, and ETL tools like PySpark, increasing ETL process efficiency by up to 50%.',
          role2:
            'Developed DataLake architecture and applied DataMesh principles to centralize raw data storage, establish domain-oriented data ownership, and define interoperability standards.',
          role3:
            'Built and maintained RESTful and GraphQL APIs to deliver ad-hoc data to stakeholders, resulting in a 20% increase in data usage and a 25% reduction in manual data processing.',
          role4:
            'Conducted data profiling and implemented data cleansing, validation, and standardization procedures, improving data quality by 30%.',
          role5:
            'Collaborated with ML engineers, Data Scientists, and Product Owners to design and maintain scalable data infrastructure for ML projects.',
          role6:
            'Adhered to Agile development, CI/CD, and industry-standard software development methodologies.',
          role7:
            'Automated manual tasks and streamlined workflows using Python, Docker, and Kubernetes, enhancing efficiency and reducing operational costs.',
          role8:
            'Created and maintained comprehensive documentation for data pipelines, processes, APIs, and systems, ensuring clarity and ease of use for cross-functional teams and stakeholders.',
        },
      ],
    },

    {
      title: 'Machine Learning Engineer Intern',
      company: 'CogniXRHealth Inc.',
      location: ' Montreal, QC, Canada',
      year: 'Jan 2022- Apr 2022',
      description: [
        {
          role1:
            'Developed CNN and RNN-based machine learning solutions to classify audio emotions during therapy sessions with an\
              accuracy of more than 82%.',
          role2:
            'Built a system to convert audio data to the text files and implemented RNN based LSTM model to generate emotions\
              from text and achieved more than 90% accuracy.',
          role3:
            'Implemented API and UI using FastAPI and React to process and display the result from ML models.',
        },
      ],
    },

    {
      title: 'Software Engineer',
      company: ' Silicon Soft Nepal',
      location: ' Kathmandu, Nepal.',
      year: 'Mar 2018- Dec 2020',
      description: [
        {
          role1:
            'Designed and developed ETL pipelines using AWS SDK for Python to extract data from multiple data sources, transform data, and load data into AWS RDS, improving data processing speed by 30%.',
          role2:
            'Created and maintained automated data pipelines by utilizing AWS S3 and RDS to transfer data between the on-premises data center and AWS, ensuring data availability and reliability.',
          role3:
            'Collaborated with Software Developers and BI Developers to develop data models, design data visualization dashboards, and deliver insights to stakeholders.',
          role4:
            'Built dynamic reports and generated insight using SQL and Python libraries such as Plotly, Seaborn, GGplot, and Matplotlib.',
          role5:
            'Designed and tuned the Data Warehouse performance by up to 20% using Database optimization techniques for OLAP operations.',
          role6: 'Conducted unit tests and peer code reviews to ensure high-quality code.',
        },
      ],
    },
  ],
};
